var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfitability(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 130,
    viewBox: "0 0 206 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.5 160.5H0.5V6C0.5 2.96243 2.96244 0.5 6 0.5H200C203.038 0.5 205.5 2.96244 205.5 6V160.5Z",
    fill: "#F3F3F3",
    stroke: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5 35C67.567 35 66 36.567 66 38.5V38.5C66 40.433 67.567 42 69.5 42H179.17C181.103 42 182.67 40.433 182.67 38.5V38.5C182.67 36.567 181.103 35 179.17 35H69.5Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5 48C67.567 48 66 49.567 66 51.5V51.5C66 53.433 67.567 55 69.5 55H135.294C137.227 55 138.794 53.433 138.794 51.5V51.5C138.794 49.567 137.227 48 135.294 48H69.5Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 97C23.567 97 22 98.567 22 100.5V100.5C22 102.433 23.567 104 25.5 104H60.5C62.433 104 64 102.433 64 100.5V100.5C64 98.567 62.433 97 60.5 97H25.5Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5 61C67.567 61 66 62.567 66 64.5V64.5C66 66.433 67.567 68 69.5 68H121.334C123.267 68 124.834 66.433 124.834 64.5V64.5C124.834 62.567 123.267 61 121.334 61H69.5Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5 74C67.567 74 66 75.567 66 77.5V77.5C66 79.433 67.567 81 69.5 81H108.37C110.303 81 111.87 79.433 111.87 77.5V77.5C111.87 75.567 110.303 74 108.37 74H69.5Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5 110C34.567 110 33 111.567 33 113.5V113.5C33 115.433 34.567 117 36.5 117H60.5C62.433 117 64 115.433 64 113.5V113.5C64 111.567 62.433 110 60.5 110H36.5Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5 87C67.567 87 66 88.567 66 90.5V90.5C66 92.433 67.567 94 69.5 94H78.5C80.433 94 82 92.433 82 90.5V90.5C82 88.567 80.433 87 78.5 87H69.5Z",
    fill: "#D1D1D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 130,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitability);
export default __webpack_public_path__ + "static/media/Profitability.a5221807301a2880486cb082a08c0659.svg";
export { ForwardRef as ReactComponent };